import { FormControl, type IFormikFormControlProps } from './FormControl'
import {
  getFormControlProps,
  getNonFormControlProps,
} from './utils/getFormControlProps'
import { type INumberFieldProps, NumberField } from '../../elements/NumberField'

export interface IFormNumberFieldProps
  extends
    Omit<INumberFieldProps, 'name' | 'id' | 'helperText'>,
    IFormikFormControlProps {
  /** Unique identifier for analytics tracking of number form field interactions. */
  analyticsId?: string
}

export const FormNumberField = (props: IFormNumberFieldProps) => {
  const { id, name, disabled, ...formControlProps } = getFormControlProps(props)
  const numberfieldProps = getNonFormControlProps(props)

  return (
    <FormControl id={id} name={name} disabled={disabled} {...formControlProps}>
      {({ value, handleChange, handleBlur, isSubmitting, error }) => (
        <NumberField
          id={name}
          name={name}
          onValueChange={(values) => handleChange(values.floatValue ?? null)}
          onBlur={handleBlur}
          error={error}
          value={value}
          disabled={isSubmitting || disabled}
          {...numberfieldProps}
          variant='standard'
        />
      )}
    </FormControl>
  )
}
